import { render, staticRenderFns } from "./suggestion-skeleton.vue?vue&type=template&id=c7c07684&scoped=true"
import script from "./suggestion-skeleton.vue?vue&type=script&lang=js"
export * from "./suggestion-skeleton.vue?vue&type=script&lang=js"
import style0 from "./suggestion-skeleton.vue?vue&type=style&index=0&id=c7c07684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c07684",
  null
  
)

export default component.exports